export default __webpack_public_path__ + "static/media/panico_1.4411ad64.png";